import { takeEvery, put, call, select } from 'redux-saga/effects';
import { productOptionActionsTypes } from '../../../types/product/option';
import { getProductOption } from '../../../../services/product/option';
import {
  getProductOptionRequestFailure,
  getProductOptionRequestSuccess,
} from '../../../actions/product/option';
import { getModifiersFilterContext } from '../../../../helpers/menuVisibility';

function* asyncProductOptionsRequest(action: any): any {
  try {
    const { id, chainProductId } = action;
    const { restaurant, rcData }: { restaurant: any; rcData: unknown } =
      yield select((state: any) => ({
        restaurant: state.restaurantInfoReducer.restaurant,
        rcData: state.menuManagementRemoteConfigReducer.data,
      }));
    const extref =
      restaurant?.extref != null && restaurant.extref !== ''
        ? String(restaurant.extref)
        : '';
    const filterCtx = getModifiersFilterContext(rcData, extref, chainProductId);

    const response = yield call(getProductOption, id, filterCtx);
    yield put(getProductOptionRequestSuccess(response));
  } catch (error) {
    yield put(getProductOptionRequestFailure(error));
  }
}

export function* productOptionsSaga() {
  yield takeEvery(
    productOptionActionsTypes.GET_PRODUCT_OPTION_REQUEST,
    asyncProductOptionsRequest,
  );
}
